import { Injectable } from '@angular/core';
import { PLAN_PRODUCTS } from '@domain/constants/app-variables';
import { Cargochief } from '../cargochief/cargochief.service';
import { UtilService } from '../util/util.service';

@Injectable({
	providedIn: 'root',
})
export class PlanProductService {
	constructor(
		private cargochief: Cargochief,
		private utilService: UtilService
	) {}

	get BOOKING_ASSISTANT(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.BOOKING_ASSISTANT);
	}

	get BOOKING_ASSISTANT_API(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.BOOKING_ASSISTANT_API);
	}

	get C4(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.C4);
	}

	get PRICING(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.PRICING);
	}

	get C4_API(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.C4_API);
	}

	get BULK_MATCHING(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.BULK_MATCHING);
	}

	get CARRIER_RECRUITING(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.CARRIER_RECRUITING);
	}

	get CAPACITY_SEARCH(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.CAPACITY_SEARCH);
	}

	get CARRIER_DEVELOPMENT(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.CARRIER_DEVELOPMENT);
	}

	get PROJECT_CARRIERS(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.PROJECT_CARRIERS);
	}

	get CARRIER_PROFILES(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.CARRIER_PROFILES);
	}

	get MULTIPLE_USERS(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.MULTIPLE_USERS);
	}

	get TASKS(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.TASKS);
	}

	get ASSIGN_CARRIERS(): boolean {
		return (
			this.cargochief.isProductEnabled(PLAN_PRODUCTS.ASSIGN_CARRIERS) && this.IS_ADMIN_OR_OWNER
		);
	}

	get IS_ADMIN_OR_OWNER(): boolean {
		return this.utilService.isUserRoleAdmin() || this.utilService.isUserRoleOwner();
	}

	get RECENT_TRANSACTIONS(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.RECENT_TRANSACTIONS);
	}

	get RFP(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.RFP);
	}

	get SCORECARDS(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.SCORECARDS);
	}

	get CUSTOMERS(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.CUSTOMERS);
	}

	get INTEGRATIONS(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.INTEGRATIONS);
	}

	get CARRIER_RATES(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.CARRIER_RATES);
	}

	get HAZMAT(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.HAZMAT);
	}

	get STRONG_LANES(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.STRONG_LANES);
	}

	get CUSTOMIZABLE_EMAILS(): boolean {
		return this.cargochief.isProductEnabled(PLAN_PRODUCTS.CUSTOMIZABLE_EMAILS);
	}
}
